<template>
  <a-layout-footer
    class="app-footer"
  >
    Beepay &copy; {{new Date().getFullYear()}} Created by Beepay-fontend
  </a-layout-footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped lang="less" type="text/less">

</style>
